angular.module('mercury.modules.time.compliance')
.config(["$stateProvider", function($stateProvider) {
  // React routes below
  $stateProvider.state('Time.Compliance.PayClassifications', {
    url: '/pay-classifications',
    controller: 'ReactCtrl',
    data: {
      menuLinkState: 'Time.Compliance.PayClassifications'
    }
  });

  $stateProvider.state('Time.Compliance.ManagePayClassifications', {
    url: '/pay-classifications/manage',
    controller: 'ReactCtrl',
    data: {
      menuLinkState: 'Time.Compliance.PayClassifications'
    }
  });

  $stateProvider.state('Time.Compliance.AddPayClassification', {
    url: '/pay-classifications/add',
    controller: 'ReactCtrl',
    data: {
      menuLinkState: 'Time.Compliance.PayClassifications'
    }
  });

  $stateProvider.state('Time.Compliance.EditPayClassification', {
    url: '/pay-classifications/:payClassificationId',
    controller: 'ReactCtrl',
    data: {
      menuLinkState: 'Time.Compliance.PayClassifications'
    }
  });

  $stateProvider.state('Time.Compliance.Leave', {
    url: '/leave-types',
    controller: 'ReactCtrl',
    data: {
      menuLinkState: 'Time.Compliance.Leave'
    }
  });

  $stateProvider.state('Time.Compliance.ManageLeaveTypes', {
    url: '/leave-types/manage',
    controller: 'ReactCtrl',
    data: {
      menuLinkState: 'Time.Compliance.Leave'
    }
  });

  $stateProvider.state('Time.Compliance.AddLeaveType', {
    url: '/leave-types/add',
    controller: 'ReactCtrl',
    data: {
      menuLinkState: 'Time.Compliance.Leave'
    }
  });

  $stateProvider.state('Time.Compliance.EditLeaveType', {
    url: '/leave-types/:leaveTypeId?view&manage',
    controller: 'ReactCtrl',
    data: {
      menuLinkState: 'Time.Compliance.Leave'
    }
  });
}]);
